import React from "react";
import {connect} from "react-redux";
import axios from "axios";
import {userService} from "../../../services/UserService";
import 'leaflet/dist/leaflet.css';
import actionTypes from "../../../store/actionTypes";
import {IStore} from "../../../store/reducers";
import Mapa from "./Mapa";
import Draggable from 'react-draggable';
import {ArrowLeft, ArrowRight} from "@material-ui/icons";
import {IParcela} from "../../../types";
import MenuVisualizador from "./MenuVisualizador";
import Escala from "./Escala";
import Zonificador from "./Zonificador";
import LeyendaZonif from "./LeyendaZonif";
import PropsZonificador from "./PropsZonificador";

const config = require('../../../config.json');


interface IProps {
    parcela: IParcela
    zonificacion: boolean
    props_zonificacion: boolean
    setProducts(products: Record<string, Record<string, string[]>>): void
}

interface Istate {
}


class Visualizador extends React.Component<IProps, Istate> {

    state:Istate = {
    }

    componentDidMount() {
        const url: string = config.url+`/get/visualizador/data?parcela=${this.props.parcela.id}`

        axios.get(
            url,
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }})
            .then((res: { data: Record<string, Record<string, string[]>> }) => {
                this.props.setProducts(res.data)
            })
            .catch(() => {})
    }

    render() {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    height: '100%'
                }}
            >
                <MenuVisualizador/>
                {this.props.zonificacion && <Zonificador/>}
                {this.props.props_zonificacion && <PropsZonificador/>}
                <Mapa/>
                <Escala/>
                <LeyendaZonif/>
            </div>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    parcela: state.visualizador.parcela,
    zonificacion: state.visualizador.zonificacion,
    props_zonificacion: state.visualizador.props_zonificacion
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    setProducts: (products: Record<string, Record<string, string[]>>) => dispatch({type: "set-visualizador-products", products})
});

export default connect(mapStateToProps, mapDispatchToProps)(Visualizador);